module.exports = __webpack_public_path__ + "img/arrow.cba65fd9.png";